/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { actualsVsPlanStatsSchema } from './actualsVsPlanStatsSchema';
import { ungroupedSchema } from './ungroupedSchema';

export const groupedSchema = z.object({
  get groups() {
    return z.union([z.array(groupedSchema), z.null()]).optional();
  },
  key: z.int(),
  get stats() {
    return actualsVsPlanStatsSchema;
  },
  get ungrouped() {
    return z.union([ungroupedSchema, z.null()]).optional();
  },
});
